import {fetchWithAuth} from '../util/fetch';
import {EndpointURL} from '../constants';
import {actionFactory} from '../util/redux-helpers';

export const ACTIONS = {
    StationsLoadingInProgress: 'stationsEndpont/STATIONS_LOADING_INPROGRESS',
    StationsLoadingCompleted: 'stationsEndpoint/STATIONS_LOADING_COMPLETED',
    StationsLoadingFailed: 'stationsEndpoint/STATIONS_LOADING_FAILED'
};

export const StationsLoadingInProgress = actionFactory(ACTIONS.StationsLoadingInProgress);
export const StationsLoadingCompleted = actionFactory(ACTIONS.StationsLoadingCompleted);
export const StationsLoadingFailed = actionFactory(ACTIONS.StationsLoadingFailed);

export function LoadActiveStationsEpic(companyId) {
  return async (dispatch) => {
    dispatch(StationsLoadingInProgress());
    try { 
      const cacheBust = new Date().getTime();
      let stationResult = await fetchWithAuth(`${EndpointURL}admin/companies/${companyId}/stations?nocache=${cacheBust}`)
      if (stationResult.status === 200){
        dispatch(StationsLoadingCompleted(await stationResult.json()));
      } else {
        dispatch(StationsLoadingFailed(await stationResult.text()));
      }
    } catch (err) { 
      dispatch(StationsLoadingFailed(err));
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/station.actions.js